<template>
  <div class="hello">
    <div>
      <div class="header">
        <div class="container">
          <img class="logo" src="../assets/logo.png" alt="" />
          <span class="float-right header-height ts-stake" @click="goStake()"
            >TS Stake</span
          >
        </div>
      </div>

      <div class="query">
        <div class="container">
          <h2>Transit Hacking Event</h2>
          <input
            type="text"
            name=""
            v-model="address"
            placeholder="Please input your wallet address to check your data"
            @keyup.enter="query()"
            id=""
          />
          <br />
          <button
            v-if="address && address.length === 42"
            class="confirm-btn"
            @click="query()"
          >
            Check
          </button>
          <button v-else class="confirm-btn disabled">Check</button>
        </div>
      </div>

      <div class="info">
        <div class="container">
          <h2>
            <img class="line" src="../assets/line.png" alt="" />
            Timeline and Progress

            <img class="line" src="../assets/line.png" alt="" />
          </h2>

          <div class="content">
            <div class="current">
              <div class="event-item">
                <span class="decorations">
                  <span class="circle">
                    <img src="../assets/radio.png" alt="" />
                  </span>
                  <span class="link"></span>
                </span>
                <span class="event-time"> Current </span>
                <span class="event-content"
                  >It is still in progress, trying our best to recover more
                  assets for users</span
                >
              </div>
            </div>

            <div class="event-list">
              <div class="event-item" v-for="(event, index) in events">
                <span class="decorations">
                  <span class="circle"> </span>
                  <span class="link" v-if="index < events.length - 1"></span>
                </span>
                <span class="event-time">
                  {{ event.time | timeformat }}
                </span>
                <span class="event-content" v-html="event.event"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Axios from "axios";

export default {
  name: "HelloWorld",
  data() {
    return {
      events: [],
      address: "",
    };
  },
  filters: {
    timeformat: (val) => {
      return dayjs(val * 1000).format("MM-DD HH:mm");
    },
  },
  created() {
    this.getEvents();
  },
  methods: {
    getEvents() {
      Axios.get("https://progress.transit.finance/finance/progress").then(
        (res) => {
          if (res.status === 200 && res.data) {
            this.events = res.data.data;
          }
        }
      );
    },
    goStake() {
      this.$router.push("/stake/ts");
    },
    query() {
      if (this.address.length === 42) {
        this.$router.push("/" + this.address);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
.header {
  width: 100%;
  height: 72px;
  border-bottom: 1px solid #e6e8ec;

  .logo {
    display: inline-block;
    height: 34px;
    margin: 18px 12px;
    vertical-align: middle;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.query {
  text-align: center;

  h2 {
    font-size: 48px;
    margin: 58px 0 34px;
    color: #3a3b3d;
  }

  input {
    max-width: 680px;
    width: 90%;
    border-radius: 10px;
    padding: 16px 24px;
    font-size: 18px;
    border: 2px solid #e6e8ea;
    box-sizing: border-box;
  }

  .confirm-btn {
    width: 90%;
    max-width: 340px;
    margin: 38px auto;
    padding: 20px;
    background: #3772ff;
    // background: #ddd;
    border: none;
    border-radius: 90px;
    font-weight: bold;
    font-size: 20px;
    color: #fff;

    &.disabled {
      background: #ddd;
    }
  }
}

.info {
  text-align: center;

  h2 {
    font-size: 24px;

    .line {
      height: 2px;
      display: inline-block;
      vertical-align: middle;
      margin: 0 12px;
    }
  }
  .container {
    background: #f4f5f6;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 32px;
    box-sizing: border-box;
  }

  .content {
    width: 80%;
    margin: 0 auto;
    max-width: 980px;
  }

  .event-item {
    position: relative;
    min-height: 86px;
  }

  .current {
    .event-item {
      min-height: 66px;
    }
    .decorations {
      .circle {
        border: 0 solid transparent;
        width: 22px;
        height: 22px;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .link {
        width: 0;
        border: 1px dashed #2f80ed;
        background: none;
        height: 80px;
      }
    }
  }

  .decorations {
    position: absolute;
    left: -32px;

    .circle {
      position: relative;
      z-index: 2;
      display: inline-block;
      width: 18px;
      height: 18px;
      border: 2px solid #6f7174;
      border-radius: 100%;
      background: #fff;
    }
    .link {
      z-index: 1;
      position: absolute;
      left: 50%;
      margin-left: -1px;
      width: 2px;
      height: 100px;
      background: #6f7174;
    }
  }

  .event-time {
    display: inline-block;
    vertical-align: top;
    width: 10%;
    text-align: left;
    color: #6f7174;
    font-weight: bold;
  }

  .event-content {
    display: inline-block;
    vertical-align: top;
    width: 86%;
    margin-left: 3%;
    text-align: left;
    color: #6f7174;
    font-weight: bold;
    // word-break: ;

    a {
      color: #2f80ed;
    }
  }
}

@media screen and (max-width: 460px) {
  .query {
    h2 {
      font-size: 24px;
    }

    input {
      padding: 12px 8px;
      font-size: 14px;
    }
    .confirm-btn {
      padding: 16px;
      font-size: 16px;
    }
  }
  .info {
    h2 {
      .line {
        display: none;
      }
    }
    .content {
      width: 90%;
    }
    .event-item {
      min-height: 146px;
    }
    .container {
      padding: 24px 8px 24px 26px;
    }
    .decorations {
      .circle {
      }
      .link {
        height: 160px;
        background: #6f7174;
      }
    }

    .event-time {
      width: 16%;
      text-align: left;
      color: #6f7174;
      font-weight: bold;
      font-size: 14px;
    }

    .event-content {
      display: inline-block;
      vertical-align: top;
      font-size: 14px;
      width: 80%;
      margin-left: 3%;
      text-align: left;
      color: #6f7174;
      font-weight: bold;

      a {
        color: #2f80ed;
      }
    }
  }
}
</style>
